export enum ToastType {
    //the values depending on the toast library types
    SUCCESS = "toast-success", ERROR = "toast-error", WARNING = "toast-warning", INFO = "toast-info"
}